export const generateReqBodyWithFiles = (data, files) => {
  const formData = new FormData();
  formData.append('data', JSON.stringify(data));
  if (files && files.length > 0) {
    for (const file of files) {
      formData.append('files', file);
    }
  }
  return formData;
};
